<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid">
	<label>Description:</label>
	<input [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="GeoFenceDesc" />

	<label>Bus:</label>
	<p-dropdown
		[disabled]="IsLoading() == true"
		[options]="lstBus"
		[(ngModel)]="Bus"
		optionLabel="BusNbr"
		[filter]="true"
		filterBy="BusNbr"
		[showClear]="false"
		placeholder="Select a bus"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="Bus">
				<div class="form-control NoBorder" style="text-align: left">
					{{ Bus.BusNbr }}
				</div>
			</div>
		</ng-template>
		<ng-template let-BusItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ BusItem.BusNbr }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Trigger Type:</label>
	<p-dropdown
		[disabled]="IsLoading() == true"
		[options]="lstGeoFenceTriggerType"
		[(ngModel)]="GeoFenceTriggerType"
		optionLabel="GeofenceTriggerTypeDesc"
		[filter]="true"
		filterBy="GeofenceTriggerTypeDesc"
		[showClear]="false"
		placeholder="Select when to create an alert"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="GeoFenceTriggerType">
				<div class="form-control NoBorder" style="text-align: left">
					{{ GeoFenceTriggerType.GeofenceTriggerTypeDesc }}
				</div>
			</div>
		</ng-template>
		<ng-template let-GeoFenceTriggerTypeItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ GeoFenceTriggerTypeItem.GeofenceTriggerTypeDesc }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Severity:</label>
	<p-dropdown
		[disabled]="IsLoading() == true"
		[options]="lstSeverity"
		[(ngModel)]="Severity"
		optionLabel="Desc"
		[filter]="true"
		filterBy="Desc"
		[showClear]="false"
		placeholder="Select a Severity Level"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="Severity">
				<div class="form-control NoBorder" style="text-align: left">
					{{ Severity.Desc }}
				</div>
			</div>
		</ng-template>
		<ng-template let-SeverityItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ SeverityItem.Desc }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Alert Comments:</label>
	<textarea
		class="form-control TextArea"
		rows="5"
		[disabled]="IsLoading() == true"
		placeholder="Custom Alert Message if any"
		[(ngModel)]="AlertComments"
	></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
